(ns frontend.ui.component.checkbox.view
  (:require
   [frontend.ui.component.checkbox.style :as style]
   [frontend.ui.component.icon.view :refer [icon]]
   [frontend.ui.component.label.view :refer [label]]
   [herb.core :refer [<class]]))

;;THIS COMPONENT USES LP-PORTAL THEMING, PLEASE ONLY USE IN LP-PORTAL

(defn checkbox
  "HTML checkbox:

  - if `custom?` is `false`, the component looks like a regular HTML checkbox
    that displays `label-true` (`label-false` is then not used).
  - if `custom?` is `true`, the component looks like a toggle that user can
    switch between values `label-true` and `label-false`."
  [{:keys [checked? on-change custom? disabled?] :as props}
   label-true
   label-false]
  [:label
   {:class (<class style/label props)}
   (if custom?
     [:span
      {:class (<class style/custom-handle)}]
     [icon
      {:styles  (style/regular-icon
                 (select-keys props
                              #{:checked?
                                :disabled?}))
       :variant :light}
      (if checked?
        :check-square
        :square)])
   [:input
    {:type      "checkbox"
     :class     (<class style/input)
     :disabled  disabled?
     :checked   checked?
     :on-change #(on-change (not checked?))}]
   [:span
    {:class (<class style/text props)}
    (if (and custom? checked?)
      label-false
      label-true)]])
